import { createContext } from 'preact';

interface Flags {
  ENABLE_DISCOUNT_APPLICATION?: boolean;
}

export const FlagContext = createContext<Flags | null>(null);
